export interface ServiceabilityEntry {
  partNumber: string
  partName: string
  quantity: number
  partType: ServiceablePartType
  changeLevel: string
  level: number
  dsgnCtlCd: string
  bomPath: string
  parent: string
  serialNumberPrefix: string
  modelVersion: string
  serviceability: ServiceabilityType
}

export enum ServiceablePartType {
  MDL = 'MDL',
  GP = 'GP',
  AS = 'AS',
  PT = 'PT',
  BK = 'BK',
  AR = 'AR',
  KT = 'KT',
  RF = 'RF',
  CATALOG = 'CATALOG',
  SECTION = 'SECTION',
  STORY = 'STORY',
  KEYLINE = 'KEYLINE',
  PART = 'PART',
}

export enum VertexPartStatus {
  OK = 'OK',
  NOGEOM = 'NOGEOM',
  MISSING = 'MISSING',
  ALTREV = 'ALTREV',
  PARTIAL = 'PARTIAL',
}

export enum ServiceabilityType {
  DISCONTINUED = 'Discontinued',
  NOT_SERVICED = 'Not Serviced',
  PENDING_DISCONTINUED = 'Pending Discontinued',
  SERVICED = 'Serviced',
  UNKNOWN = 'Unknown',
}

export enum ServiceItemMetadata {
  PART_NUMBER = 'SERVICE_PART_NUMBER',
  PART_NAME = 'SERVICE_PART_NAME',
  PART_TYPE = 'SERVICE_PART_TYPE',
  CHANGE_LEVEL = 'SERVICE_CHANGE_LEVEL',
  BOM_LEVEL = 'SERVICE_BOM_LEVEL',
  DSGN_CTL_CD = 'SERVICE_DSGN_CTL_CD',
  BOM_PATH = 'SERVICE_BOM_PATH',
  PARENT = 'SERVICE_PARENT',
  VERTEX_BOM_PATH = 'VERTEX_BOM_PATH',
  VERTEX_PARENT_BOM_PATH = 'VERTEX_PARENT_BOM_PATH',
  SN_PREFIX = 'SERVICE_SN_PREFIX',
  MODEL_VERSION = 'SERVICE_MODEL_VERSION',
  QUANTITY = 'SERVICE_QUANTITY',
  SERVICEABILITY = 'SERVICEABILITY',
  SOURCE_SCENE_ITEM = 'VERTEX_SOURCE_SCENE_ITEM',
  HAS_GEOMETRY_VERTEX = 'HAS_GEOMETRY_VERTEX',
  HAS_PLM_VERTEX = 'HAS_PLM_VERTEX',
  PART_INSTANCE_COUNT_VERTEX = 'PART_INSTANCE_COUNT_VERTEX',
  VERTEX_STATS = 'VERTEX_STATS',
  MISSING_PARTS = 'MISSING_PARTS',
  PART_PLM_COUNT_VERTEX = 'PART_PLM_COUNT_VERTEX',
  PART_GEOMETRY_VERTEX = 'PART_GEOMETRY_VERTEX',
  ITEM_COUNT = 'ITEM_COUNT',
  BOM_LINE_COUNT = 'BOM_LINE_COUNT',
  VERTEX_SOURCE_SCENE_ITEM = 'VERTEX_SOURCE_SCENE_ITEM',
  VERTEX_SCENE_ITEM_COUNT = 'VERTEX_SCENE_ITEM_COUNT',
  CATALOG_NAME = 'CATALOG_NAME',
}
